import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";
import { PolicyControl } from "../../policy/policySections/PolicySections.types";

// The pickable framework controls for the risk module. Gated server-side by risk access (not framework
// read), so risk users can link controls without holding framework permissions.
export function useSelectableControlsForRisk() {
    return useDotLegalQueryWithKey<Array<PolicyControl>>("selectableFrameworkControlsForRisk", "/risk-assessments/selectable-controls");
}

// The linked-controls section is only worth showing when there is something to pick from, or when the item
// already carries links (so previously-linked controls stay editable even after the pickable set empties out).
// Create-only surfaces with no pre-existing links pass an empty array.
export function useLinkedControls(currentControlIds: Array<string>) {
    const availableControls = useSelectableControlsForRisk().data ?? [];
    const showLinkedControls = availableControls.length > 0 || currentControlIds.length > 0;
    return { availableControls, showLinkedControls };
}
